import type { JSX } from 'react'
import type { ITextBoxProps } from 'atoms/TextBox'
import type { ITextBlockProps } from '../../TextBlock'

import { Icon, IconNames } from 'atoms/Icon'
import { TextBoxMaxLine1Headline3Secondary } from 'atoms/TextBox/Templates'
import { TextBlock } from '../../TextBlock'
import { TextBlockAlignItems, TextBlockJustifyContent } from '../../TextBlock.h'

export interface INoContentTextBlockProps extends ITextBlockProps {
  title: ITextBoxProps['title']
}

export const NoContentTextBlock = ({
  title = '',
  alignItems = TextBlockAlignItems.Center,
  justifyContent = TextBlockJustifyContent.Center,
  flexGrow = 1,
  ...rest
}: INoContentTextBlockProps): JSX.Element => (
  <TextBlock
    alignItems={alignItems}
    justifyContent={justifyContent}
    flexGrow={flexGrow}
    {...rest}
  >
    <Icon name={IconNames.noContent} />
    <TextBoxMaxLine1Headline3Secondary title={title} />
  </TextBlock>
)
